import AdminLayout from "../components/AdminLayout";
import TableAdmin from "../components/TableAdmin";

const Admin = () => {
  return (
    <AdminLayout title="Products" stats="default">
      <TableAdmin />
    </AdminLayout>
  );
};

export default Admin;
